import React, { useEffect, useState } from 'react';
import ReactJoyride, { STATUS } from 'react-joyride';
import { useLocation } from 'react-router-dom';

const Demo = ({ onClose, showHelp }) => {
    const [run, setRun] = useState(false);
    const [stepsVisible, setStepsVisible] = useState(false);
    const location = useLocation();

    const defaultSteps = [
        {
            content: <h2>Bienvenue sur le guide d'utilisation de Rivka Traiteur</h2>,
            placement: 'center',
            target: 'body',
            stepIndex: 0
        }
    ];

    const menuSteps = [
        {
            target: '.flex.items-end',
            content: 'Puis sélectionnez votre formule ou ajoutez des produits au panier.',
        },
        {
            target: '#menu-title',
            content: 'Regardez bien le titre, il vous indique où vous en êtes dans le processus de commande.',
        },
        {
            target: '#cart-content',
            content: 'Vérifiez minutieusement votre panier.',
        },
        {
            target: '#cart-button',
            content: 'Cliquez sur Suivant pour passer à la suite ou validez le panier si vous avez terminé',
        }
    ];

    const paymentSteps = [
        {
            content: <h2>Finalisons votre commande en remplissant vos informations</h2>,
            placement: 'center',
            target: 'body',
            stepIndex: 0
        },
        {
            target: '#delivery_address',
            content: 'Étape 1: Vérifiez votre adresse de livraison.',
            stepIndex: 1
        },
        {
            target: '#delivery_lastname',
            content: 'Étape 2: Remplissez vos informations personnelles de livraison.',
            stepIndex: 2
        },
        {
            target: '#delivery_message',
            content: 'Étape 3: Ajoutez des instructions spéciales pour la livraison (étage, digicode...).',
            stepIndex: 3
        },
        {
            target: '#billing_address',
            content: 'Étape 4: Remplissez votre adresse de facturation si différente.',
            stepIndex: 4
        },
        {
            target: '#billing_lastname',
            content: 'Étape 5: Complétez vos informations de facturation.',
            stepIndex: 5
        },
        {
            target: '#billing_email',
            content: 'Étape 6: Indiquez votre email pour recevoir la confirmation de commande.',
            stepIndex: 6
        },
        {
            target: '.p-2.flex.flex-col.items-center.shadow-lg.rounded-lg.bg-white.md\\:flex-row.md\\:justify-around.md\\:mb-4',
            content: 'Étape 7: Sélectionnez votre date de livraison souhaitée.',
            stepIndex: 7
        },
        {
            target: 'button[type="submit"]',
            content: 'Étape 8: Une fois tous les champs remplis, le bouton de paiement sera activé.',
            stepIndex: 8
        }
    ];

    const categoriesSteps = [
        {
            content: <h2>Une fois validé votre ou vos formules, voici comment composer votre Shabbat</h2>,
            placement: 'center',
            target: 'body',
            stepIndex: 0
        },
        {
            target: '.flex.items-end',
            content: 'Sélectionnez votre formule ou ajoutez des produits au panier.',
            stepIndex: 1
        },
        {
            target: '.opacity-0.hover\\:opacity-100',
            content: 'Pour modifier la quantité d\'un produit, survolez l\'image et utilisez les boutons + et - pour ajuster la quantité souhaitée.',
            stepIndex: 2
        },
        {
            target: '#menu-title',
            content: 'Regardez bien le titre, il vous indique combien de produits vous devez ajouter.',
            stepIndex: 3
        },
        {
            target: '#menu-title',
            content: 'Le titre vous indique où vous en êtes dans le processus de commande.',
            stepIndex: 4
        },
        {
            target: '#cart-content',
            content: 'Étape 5: Vérifiez minutieusement votre panier. Faites défiler vers le bas pour voir tous les produits inclus.',
            placement: 'left',
            stepIndex: 5
        },
        {
            target: '#cart-content',
            content: 'Assurez-vous que tous les produits et leurs quantités sont corrects avant de continuer.',
            placement: 'left',
            stepIndex: 6
        },
        {
            target: '#cart-button',
            content: 'Cliquez sur Suivant pour passer à la suite ou validez le panier si vous avez terminé',
            stepIndex: 7
        }
    ];

    const conditionalSteps = () => {
        switch (location.pathname) {
            case '/commande/menu':
                return menuSteps;
            case '/commande/menu/categories':
                return categoriesSteps;
            case '/commande/paiement':
                return paymentSteps;
            default:
                return defaultSteps;
        }
    };

    const steps = conditionalSteps();

    const handleJoyrideCallback = (data) => {
        const { status, index, step } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        console.log(`Étape actuelle: ${step.stepIndex}`);
        console.log(`Cible de l'étape: ${step.target}`);
        console.log(`Nombre total d'étapes: ${steps.length}`);

        if (finishedStatuses.includes(status)) {
            onClose();
            setStepsVisible(false);
        } else {
            console.log(`Transition vers l'étape suivante: ${index + 1}`);
        }
    };

    useEffect(() => {
        if (showHelp) {
            setRun(true);
            setStepsVisible(true);

            // Vérification de la présence des éléments cibles
            steps.forEach((step, i) => {
                const element = document.querySelector(step.target);
                if (element) {
                    console.log(`Élément trouvé pour ${step.target} à l'étape ${i}`);
                } else {
                    console.log(`Élément non trouvé pour ${step.target} à l'étape ${i}`);
                }
            });
        }
    }, [showHelp]);

    return (
        <div>
            {stepsVisible && (
                <ReactJoyride
                    steps={steps}
                    run={run}
                    continuous
                    callback={handleJoyrideCallback}
                    showProgress
                    locale={{
                        nextLabelWithProgress: 'Suivant ',
                        next: 'Suivant',
                        skip: 'Passer',
                        close: 'Fermer',
                        last: 'Terminer',
                        back: 'Retour',
                    }}
                    styles={{
                        options: {
                            arrowColor: '#A2924A',
                            primaryColor: '#A2924C',
                        },
                    }}
                />
            )}
        </div>
    );
};

export default Demo;